export enum WaveGroupType {
  VIEW = "VIEW",
  DROP = "DROP",
  VOTE = "VOTE",
  CHAT = "CHAT",
  ADMIN = "ADMIN",
}
